import RightBottomPanel from "./RightBottomPanel";
import RightTopPanel from "./RightTopPanel";

export default function RightPanel() {
  return (
    <div className="flex h-full flex-1 flex-col gap-5 overflow-hidden">
      <RightTopPanel />
      <RightBottomPanel />
    </div>
  );
}
